import { useNavigate } from "react-router-dom";
import "./restaurant-customercenter.styles.scss";
const RestaurantCustomerCenter = () => {
  const navigate = useNavigate();
  const optionsObject = {
    Loyalty_Programs: {
      message: "Reward your customers with loyalty benefits.",
      classValue: "one",
      navigateTo: "loyalty",
    },
    Offers: {
      message: "Order specific offers.",
      classValue: "two",
      navigateTo: "offers",
    },
    Feedback: {
      message: "Show the customers that their complaints are heard",
      classValue: "three",
      navigateTo: "",
    },
    Customer_Messaging: {
      message: "Knock, knock. Who's there? A customer.",
      classValue: "four",
      navigateTo: "",
    },
  };
  return (
    <div className="customer-center-container">
      <div className="customer-center-icons">
        {Object.keys(optionsObject).map((index) => {
          const nameValue = index.replace("_", " ");
          const tempObject = optionsObject[index];
          const classValue = "customer-center-icon " + tempObject["classValue"];
          return (
            <div
              key={index}
              className={classValue}
              onClick={() => navigate(tempObject["navigateTo"])}
            >
              <span className="customer-center-icon-name">{nameValue}</span>
              <br />
              <span className="customer-center-icon-message">
                {tempObject["message"]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default RestaurantCustomerCenter;
